// Custom.js

// Wishlist JS exported
(function (Wishlist) {
  const $wishlistTile = document.querySelectorAll(".wishlist-tile-container");
  let numProductTiles = $wishlistTile.length;

  const wishlist = JSON.parse(localStorage.getItem("user_wishlist") || "[]");

  const animateWishlist = (btn) => btn.classList.toggle("is-active");

  const updateWishlist = (btn) => {
    const productHandle = btn.getAttribute("data-product-handle-wishlist");
    const isRemove = btn.classList.contains("is-active");

    if (isRemove) {
      const idx = wishlist.indexOf(productHandle);
      if (idx > -1) wishlist.splice(idx, 1);
    } else if (!wishlist.includes(productHandle)) {
      wishlist.push(productHandle);
    }
    localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
  };

  Wishlist.markActiveButtons = function (root = document) {
    root.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle-wishlist");
      if (wishlist.includes(handle)) btn.classList.add("is-active");
    });
  };

  const displayOnlyWishlistItems = () => {
    document.querySelectorAll(".wishlist-tile-container").forEach((tile) => {
      const handle = tile.getAttribute("data-product-handle-wishlist");
      if (!wishlist.includes(handle)) {
        tile.remove();
        numProductTiles--;
      }
    });
  };

  const loadWishlist = () => {
    if (!window.location.href.includes("pages/wish-list")) return;

    setTimeout(displayOnlyWishlistItems, 1000);

    const loader       = document.querySelector(".wishlist-loader");
    const wishlistGrid = document.querySelector(".wishlist-grid");
    const wishlistHero = document.querySelector(".wishlist-hero");
    const emptyList    = document.querySelector(".wishlist-grid--empty-list");

    if (!loader) return;

    loader.style.transition = "opacity 2s";
    loader.style.opacity    = 0;

    setTimeout(() => {
      loader.style.display = "none";
      wishlistGrid?.classList.add("is_visible");
      wishlistHero?.classList.add("is_visible");

      if (emptyList) {
        if (numProductTiles === 0) emptyList.classList.add("is_visible");
        else emptyList.style.display = "none";
      }

      buildShareButtonLink();
    }, 2000);
  };

  const bindUIActions = (() => {
    let isBound = false;
    return () => {
      if (isBound) return;
      isBound = true;

      document.addEventListener(
        "click",
        (e) => {
          const btn = e.target.closest(".wishlist-btn");
          if (!btn) return;

          if (btn.dataset.busy === "1") return;
          btn.dataset.busy = "1";

          updateWishlist(btn);
          animateWishlist(btn);

          delete btn.dataset.busy;
        },
        { passive: true }
      );
    };
  })();

  const buildShareButtonLink = () => {
    let link = "mailto:?subject=Checkout my wishlist on Lambs and Ivy&body=";

    document.querySelectorAll(".wishlist-grid .product-title").forEach((title) => {
      link += `%0D${title.innerText.trim()}%0D${title.href}%0D%0D`;
    });

    document.querySelector("a.share")?.setAttribute("href", link);
  };

  Wishlist.init = () => {
    bindUIActions();
    Wishlist.markActiveButtons();
    loadWishlist();
    //buildShareButtonLink();
  };
})(window.Wishlist = window.Wishlist || {});

document.addEventListener("barba:afterEnter", (e) => {
  Wishlist.markActiveButtons(e.detail.next.container);
});

function showModal(selector) {
  const modal = document.querySelector(selector);
  if (!modal) return;
  modal.style.display = "block";
  setTimeout(() => {
    modal.style.display = "none";
  }, 5000);
}

function initWishlist() {
  document.querySelectorAll(".grid-item button.wishlist").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      const form = button.parentElement;
      const item = form.closest(".grid-item");
      const formData = new FormData(form);

      try {
        showLoading();
        const response = await fetch("/contact", {
          method: "POST",
          body: new URLSearchParams(formData),
        });
        if (!response.ok) throw response;

        hideLoading();
        form.innerHTML = `
            <a class="wishlist" href="/pages/wish-list" title="Go to wishlist">
              <span class="icon"></span><span>Go to wishlist</span>
            </a>
          `;

        const title = item.querySelector(".product-title")?.innerHTML || "";
        const image = item.querySelector("a > img")?.getAttribute("src") || "";
        const modal = document.querySelector(".ajax-success-modal");
        if (!modal) return;

        modal.querySelector(".ajax-product-title").innerHTML = title;
        modal.querySelector(".ajax-product-image").setAttribute("src", image);
        modal.querySelector(".btn-go-to-wishlist").style.display = "block";
        modal.querySelector(".btn-go-to-cart").style.display = "none";

        showModal(".ajax-success-modal");
      } catch (err) {
        hideLoading();
        const modal = document.querySelector(".ajax-error-modal");
        const message = document.querySelector(".ajax-error-message");
        if (modal && message) {
          const res = await err.json();
          message.textContent = res.description;
          showModal(".ajax-error-modal");
        }
      }
    });
  });
}

function initProductWishlist() {
  document.querySelectorAll(".product button.wishlist").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      const form = button.parentElement;
      const formData = new FormData(form);

      try {
        showLoading();
        const response = await fetch("/contact", {
          method: "POST",
          body: new URLSearchParams(formData),
        });
        if (!response.ok) throw response;

        hideLoading();
        form.innerHTML = `
            <a class="wishlist" href="/pages/wish-list" title="Go to wishlist">
              <span class="icon"></span><span>Go to wishlist</span>
            </a>
          `;

        const title = document.querySelector(".product-title h2")?.innerHTML || "";
        const image = document.getElementById("product-featured-image")?.getAttribute("src") || "";
        const modal = document.querySelector(".ajax-success-modal");
        if (!modal) return;

        modal.querySelector(".ajax-product-title").innerHTML = title;
        modal.querySelector(".ajax-product-image").setAttribute("src", image);
        modal.querySelector(".btn-go-to-wishlist").style.display = "block";
        modal.querySelector(".btn-go-to-cart").style.display = "none";

        showModal(".ajax-success-modal");
      } catch (err) {
        hideLoading();
        const modal = document.querySelector(".ajax-error-modal");
        const message = document.querySelector(".ajax-error-message");
        if (modal && message) {
          const res = await err.json();
          message.textContent = res.description;
          showModal(".ajax-error-modal");
        }
      }
    });
  });
}

function initRemoveWishlist() {
  document.querySelectorAll(".btn-remove-wishlist").forEach((button) => {
    button.addEventListener("click", async () => {
      const row = button.closest("tr");
      const tagID = row.querySelector(".tag-id")?.value || "";
      const form = document.getElementById("remove-wishlist-form");
      if (!form) return;

      form.querySelector("input[name='contact[tags]']").value = `x${tagID}`;
      const formData = new FormData(form);

      try {
        showLoading();
        const response = await fetch("/contact", {
          method: "POST",
          body: new URLSearchParams(formData),
        });
        if (!response.ok) throw response;

        hideLoading();
        row.style.transition = "opacity 1s";
        row.style.opacity = 0;
        setTimeout(() => row.remove(), 1000);
      } catch (err) {
        hideLoading();
        const modal = document.querySelector(".ajax-error-modal");
        const message = document.querySelector(".ajax-error-message");
        if (modal && message) {
          const res = await err.json();
          message.textContent = res.description;
          showModal(".ajax-error-modal");
        }
      }
    });
  });
}

function showLoading() {
  const modal = document.querySelector(".loading-modal");
  if (modal) modal.style.display = "block";
}

function hideLoading() {
  const modal = document.querySelector(".loading-modal");
  if (modal) modal.style.display = "none";
}

document.addEventListener("DOMContentLoaded", () => {
  Wishlist.init();
  initWishlist();
  initProductWishlist();
  initRemoveWishlist();

  const firstTile = document.querySelector(".wishlist-tile-container");
  firstTile?.classList.add("wishlist-first");
});

document.querySelectorAll(".wishlist-grid .wishlist-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const tile = btn.closest(".wishlist-tile-container");
    if (!tile) return;
    tile.style.transition = "opacity 1s";
    tile.style.opacity = 0;
    setTimeout(() => (tile.style.display = "none"), 1000);
  });
});
// End Wishlist JS exported
